import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  SelectInputComponent,
  NumberInputComponent,
} from '@navstation-portal/shared/ui/components';
import { SelectOption } from '@navstation-portal/shared/data-model/common';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreConsumptionsFormEvents,
  OffshoreConsumptionsFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-cylinder-oil-production',
  templateUrl: './cylinder-oil-production.component.html',
  styleUrl: './cylinder-oil-production.component.css',
  imports: [FormsModule, SelectInputComponent, NumberInputComponent],
})
export class CylinderOilProductionComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'consumptions';
  sectionId = 'cylinderOilConsumption';
  events = injectDispatch(offshoreConsumptionsFormEvents);
  consumptionsStore = inject(OffshoreConsumptionsFormStore);

  readonly OIL_CODE_OPTIONS: SelectOption[] = [
    { name: 'Normal Operation', code: 1 },
    { name: 'Running In', code: 2 },
    { name: 'Damaged Liner', code: 3 },
    { name: 'Units Cut Off', code: 4 },
  ] as const;
}
